<script setup lang="ts">
import { useLenisStore, useTemplateRef } from '#imports'

const props = defineProps<{
  title: string
  expanded: boolean
}>()

defineEmits<{
  toggle: []
}>()

const lenisStore = useLenisStore()
const rootEl = useTemplateRef<HTMLElement>('rootEl')

const handleTransitionEnd = (event: TransitionEvent) => {
  if (event.propertyName !== 'grid-template-rows') return
  if (!props.expanded) return
  if (!rootEl.value) return
  lenisStore.scrollTo(rootEl.value, { offset: -150 })
}
</script>

<template>
  <div
    ref="rootEl"
    class="flex flex-col overflow-hidden"
  >
    <button
      class="flex flex-row justify-between items-center py-5 px-7.5 cursor-pointer rounded-3xl text-left"
      :class="expanded ? 'bg-background-1' : 'bg-background-2'"
      @click="$emit('toggle')"
    >
      <span class="text-H4 text-Tekst">{{ title }}</span>

      <i
        class="text-2xl text-Background_1 duration-200"
        :class="expanded ? 'pi pi-times' : 'pi pi-chevron-down'"
      />
    </button>

    <div
      :class="expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
      class="grid transition-[grid-template-rows] duration-200 ease-in-out"
      @transitionend="handleTransitionEnd"
    >
      <div class="overflow-hidden">
        <slot />
      </div>
    </div>
  </div>
</template>
